import React from "react";

import { ColorCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function color({ width, onResize }: Column.Options) {
	return base(ColumnId.Color, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default color;
